"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormDatosFiscales = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormDatosFiscales extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleChangeFields = this.handleChangeFields.bind(this);
  }

  handleChangeFields(event) {
    this.props.onChange(event.target.value, event.target.name);
  }

  render() {
    const {
      nombre,
      apellido,
      dni,
      cuit_cuil,
      razon_social,
      domicilio_fiscal,
      id_condicion_fiscal,
      ingresos_brutos
    } = this.props;
    return (0, _react2.jsx)("div", null, (0, _react2.jsx)(_material.Box, {
      mt: 2
    }, (0, _react2.jsx)(_material.Box, {
      mb: 2,
      mt: 2
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, "Datos Fiscales")), (0, _react2.jsx)(_material.Grid, {
      container: true,
      justifyContent: "space-between"
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      label: "Nombre",
      variant: "standard",
      name: "nombre",
      defaultValue: nombre,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      label: "Apellido",
      variant: "standard",
      name: "apellido",
      defaultValue: apellido,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      label: "DNI",
      variant: "standard",
      type: "text",
      onInput: () => "numberOnly(dni)",
      inputProps: {
        maxLength: 8
      },
      name: "dni",
      defaultValue: dni,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      label: "CUIT",
      variant: "standard",
      type: "text",
      name: "cuit_cuil",
      defaultValue: cuit_cuil,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      label: "Raz\xF3n Social",
      variant: "standard",
      name: "razon_social",
      defaultValue: razon_social,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      label: "Domicilio Fiscal",
      variant: "standard",
      name: "domicilio_fiscal",
      defaultValue: domicilio_fiscal,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.separacion
    }, (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Condici\xF3n Fiscal",
      select: true,
      value: id_condicion_fiscal ? id_condicion_fiscal : [],
      name: "id_condicion_fiscal",
      onChange: e => this.handleChangeFields(e)
    }, (0, _react2.jsx)(_material.MenuItem, {
      value: 1
    }, "Consumidor Final"), (0, _react2.jsx)(_material.MenuItem, {
      value: 2
    }, "Responsable Monotributo"), (0, _react2.jsx)(_material.MenuItem, {
      value: 3
    }, "Responsable Inscripto"), (0, _react2.jsx)(_material.MenuItem, {
      value: 4
    }, "Exento"), (0, _react2.jsx)(_material.MenuItem, {
      value: 5
    }, "Responsable No Inscripto")))), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, (0, _react2.jsx)(_material.TextField, {
      label: "Ingresos Brutos",
      variant: "standard",
      name: "ingresos_brutos",
      defaultValue: ingresos_brutos,
      onBlur: e => this.handleChangeFields(e),
      css: _style.default.separacion
    })))));
  }

}

exports.FormDatosFiscales = FormDatosFiscales;
var _default = FormDatosFiscales;
exports.default = _default;